import { OverlayPosition } from '../../../../../../ui/gzInfoOverlay/type';
import { InProductTrialsOverlayWindowType } from '../../../types/InProductTrialsOverlayWindowType';
import { MenuState } from '../../types/MenuState';
import { MenuItem } from '../../types/MenuItem';

export function getTargetForMenuStateByMenuItem(menuState: MenuState): {
  [menuItem in MenuItem]: string;
} {
  const menuItemPrefix = 'menu_item_';
  const menuItemSuffix = '_parent';

  return {
    [MenuItem.Incidents]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.Incidents + menuItemSuffix
        : menuItemPrefix + MenuItem.Incidents,
    [MenuItem.NetworkV2]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.NetworkV2 + menuItemSuffix
        : menuItemPrefix + MenuItem.NetworkV2,
    [MenuItem.MobileSecurity]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.MobileSecurity + menuItemSuffix
        : menuItemPrefix + MenuItem.MobileSecurity,
    [MenuItem.Monitoring]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.Monitoring + menuItemSuffix
        : menuItemPrefix + MenuItem.Monitoring,
    [MenuItem.InstallationPackages]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.NetworkV2 + menuItemSuffix
        : menuItemPrefix + MenuItem.InstallationPackages,
    [MenuItem.NetworkV2]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.NetworkV2 + menuItemSuffix
        : menuItemPrefix + MenuItem.NetworkV2,
    [MenuItem.HealthDashboard]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.Monitoring + menuItemSuffix
        : menuItemPrefix + MenuItem.HealthDashboard,
    [MenuItem.Compliance]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.RiskManagement + menuItemSuffix
        : menuItemPrefix + MenuItem.Compliance,
    [MenuItem.RiskManagement]:
      menuState === MenuState.Collapsed
        ? menuItemPrefix + MenuItem.RiskManagement + menuItemSuffix
        : menuItemPrefix + MenuItem.RiskManagement,
  };
}

function getInProductTrialsOverlayWindowConfig(menuState: MenuState): {
  [type in InProductTrialsOverlayWindowType]: { target: string; position: OverlayPosition };
} {
  const inProductTrialsButtonTarget = 'inProductTrials';
  const targetsByMenuItem = getTargetForMenuStateByMenuItem(menuState);

  // common configs
  const commonTrialsButtonConfig = {
    target: inProductTrialsButtonTarget,
    position: OverlayPosition.TOP_RIGHT,
  };
  const commonIncidentsConfig = {
    target: targetsByMenuItem[MenuItem.Incidents],
    position: OverlayPosition.LEFT_TOP,
  };
  const commonNetworkConfig = {
    target: targetsByMenuItem[MenuItem.NetworkV2],
    position: OverlayPosition.LEFT_TOP,
  };

  return {
    // new section
    [InProductTrialsOverlayWindowType.ProductTrialsHubNewSection]: commonTrialsButtonConfig,

    // ready to try
    [InProductTrialsOverlayWindowType.OfficeSecurityPackReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.NextGenIncidentsReadyToTry]: commonIncidentsConfig,
    [InProductTrialsOverlayWindowType.NextGenWithReconfigureReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.AtdIncidentsReadyToTry]: commonIncidentsConfig,
    [InProductTrialsOverlayWindowType.PatchManagementNetworkReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.VolumeEncryptionNetworkReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.MobileSecurityMobileReadyToTry]: {
      target: targetsByMenuItem[MenuItem.MobileSecurity],
      position: OverlayPosition.LEFT_BOTTOM,
    },
    [InProductTrialsOverlayWindowType.IntegrityMonitorReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.ContainerProtectionReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.StorageProtectionReadyToTry]: {
      target: targetsByMenuItem[MenuItem.InstallationPackages],
      position: OverlayPosition.LEFT_TOP,
    },
    [InProductTrialsOverlayWindowType.XdrFullReadyToTry]: commonIncidentsConfig,
    [InProductTrialsOverlayWindowType.XdrSensorsReadyToTry]: commonIncidentsConfig,
    [InProductTrialsOverlayWindowType.NadAndEraReadyToTry]: commonNetworkConfig,
    [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlReadyToTry]: commonNetworkConfig,

    // trial ended
    [InProductTrialsOverlayWindowType.OfficeSecurityPackTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.NextGenTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.NextGenWithReconfigureTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.AtdTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.PatchManagementTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.VolumeEncryptionTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.MobileSecurityTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.IntegrityMonitorTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.ContainerProtectionTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.StorageProtectionTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.XdrFullTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.XdrSensorsTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.NadAndEraTrialEnded]: commonTrialsButtonConfig,
    [InProductTrialsOverlayWindowType.WebAccessAndDeviceControlTrialEnded]: commonTrialsButtonConfig,
  };
}

export function getInProductTrialsOverlayWindowConfigByWindowType(
  overlayWindowType: InProductTrialsOverlayWindowType,
  menuState: MenuState
): { target: string; position: OverlayPosition } {
  return getInProductTrialsOverlayWindowConfig(menuState)[overlayWindowType];
}
